<script>
import { useLocation, useNavigate } from "svelte-navigator";
import LoginEmail from './LoginEmailOnly.svelte';
import LoginEmailPassword from './LoginEmailPassword.svelte';
import LoginGlobalPassword from './LoginGlobalPassword.svelte';
import LoginOpenRegistrationGlobalPassword from './LoginOpenRegistrationGlobalPassword.svelte';
import LoginOpenRegistration from './LoginOpenRegistration.svelte';
import LoginPreinvite from './LoginPreinvite.svelte';
import LoginOpenRegistrationNoOrgOrTitle from "./LoginOpenRegistrationNoOrgOrTitle.svelte";
import LoginOpenRegistrationGlobalPasswordNoOrg from './LoginOpenRegistrationGlobalPasswordNoOrg.svelte';
// import LoginRegister from './LoginRegister.svelte';
import LoginTicketing from './LoginTicketing.svelte';

// Notice! This uses the knowledge of the tabs that are used together with login methods
const Expand = {
  'loginpreinvite': { path: '/login', component: LoginPreinvite },

  'global': { path: '/signin', component: LoginGlobalPassword },
  'loginemail': { path: '/signin', component: LoginEmail },
  'loginemailpassword': { path: '/signin', component: LoginEmailPassword },
  'loginopenwithglobalpassword': { path: '/signin', component: LoginOpenRegistrationGlobalPassword },
  'loginopenwithglobalpasswordnoorg': { path: '/signin', component: LoginOpenRegistrationGlobalPasswordNoOrg },
  'loginopenregistration': { path: '/signin', component: LoginOpenRegistration },
  'loginopenregistrationnoorgortitle': { path: '/signin', component: LoginOpenRegistrationNoOrgOrTitle },
  'loginticketing': { path: '/signup', component: LoginTicketing },
}

export let tabs;

const location = useLocation();
const navigate = useNavigate();

let _tabs;
let path;

$: _tabs = tabs.map(t => ({...t, ...Expand[t.component.toLowerCase()]}))
$: path = $location.pathname;
$: activeTab = _tabs.find(t => t.path === path) || _tabs[0]
</script>

<div class="box">
  <div class="flex flex-1">
    {#each _tabs as tab}
      <div class="tab center-all" class:active={activeTab === tab} on:click={() => navigate(tab.path, { replace: true })}>{tab.tabTitle}</div>
    {/each}
  </div>

  <div class="content flex flex-col">
    <svelte:component this={activeTab.component} {...activeTab} />
  </div>
</div>

<style lang="scss">
@import '../util';
@import '../login';

.tab {
  flex: 1;
  height: 62px;
  background-color: var(--primary);
  color: var(--text-primary);
  font-size: 24px;
  font-weight: 800;
  cursor: pointer;
  user-select: none;
  overflow-x: hidden; // for development
}

.tab.active {
  background-color: white;
  color: black;
}
</style>